module.exports = __webpack_public_path__ + "assets/images/pages/creando/laus.png?d87b795e";